import type { Variants } from 'framer-motion';

export const duration = {
  instant: 0,
  fast: 100,
  normal: 200,
  slow: 300,
  slower: 500,
} as const;

export const easing = {
  /** cubic-bezier — smooth UI default */
  default: [0.4, 0, 0.2, 1] as const,
  in: [0.4, 0, 1, 1] as const,
  out: [0, 0, 0.2, 1] as const,
  inOut: [0.4, 0, 0.2, 1] as const,
} as const;

const ms = (n: number) => `${n}ms`;

export const transition = {
  fast: `opacity ${ms(duration.fast)}ms cubic-bezier(${easing.default.join(', ')})`,
  default: `all ${ms(duration.normal)}ms cubic-bezier(${easing.default.join(', ')})`,
  slow: `all ${ms(duration.slow)}ms cubic-bezier(${easing.default.join(', ')})`,
  colors: `color ${ms(duration.fast)}ms ease, background-color ${ms(duration.fast)}ms ease, border-color ${ms(duration.fast)}ms ease`,
  transform: `transform ${ms(duration.normal)}ms cubic-bezier(${easing.out.join(', ')})`,
} as const;

export const motionVariants: Record<string, Variants> = {
  fadeIn: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  },
  slideUp: {
    initial: { opacity: 0, y: 8 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 8 },
  },
  slideDown: {
    initial: { opacity: 0, y: -8 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -8 },
  },
  scaleIn: {
    initial: { opacity: 0, scale: 0.96 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.96 },
  },
};
